import { toProtectedFileUrl } from './secureFile';

/** Buka preview file di dalam app (modal), tanpa tab baru ke URL backend. */
export function openInAppFilePreview({ url, urls, labels, title, activeIndex = 0 } = {}) {
  const raw = Array.isArray(urls) && urls.length
    ? urls.filter(Boolean)
    : (url ? [url] : []);
  const list = raw.map((u) => toProtectedFileUrl(u)).filter(Boolean);
  if (!list.length) return;
  const safeIndex = Number.isInteger(activeIndex) && activeIndex >= 0 && activeIndex < list.length
    ? activeIndex
    : 0;
  window.dispatchEvent(new CustomEvent('in-app-file-preview', {
    detail: {
      urls: list,
      labels: Array.isArray(labels) ? labels : list.map((_, i) => `File ${i + 1}`),
      title: title || 'Preview File',
      activeIndex: safeIndex,
    },
  }));
}

export function isProbablyBackendFileUrl(href) {
  if (!href || typeof href !== 'string') return false;
  if (href.startsWith('blob:') || href.startsWith('data:')) return true;
  const base = process.env.REACT_APP_URL || 'http://localhost:5100';
  return (
    href.startsWith(base) ||
    href.includes('/files/') ||
    href.includes('/images/') ||
    href.includes('/rab/file/') ||
    href.includes('/ba/') ||
    /^https?:\/\/(localhost|127\.0\.0\.1):5100\//i.test(href)
  );
}
